/* tslint:disable */
/* eslint-disable */
/**
 * Dataland User Service API documentation
 * Manage User Portfolios and more
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../../../../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../../../../../base';
// @ts-ignore
import type { BasePortfolio } from '../../../../../../org/dataland/datalandfrontend/openApiClient/userservice/model';
// @ts-ignore
import type { BasePortfolioName } from '../../../../../../org/dataland/datalandfrontend/openApiClient/userservice/model';
// @ts-ignore
import type { EnrichedPortfolio } from '../../../../../../org/dataland/datalandfrontend/openApiClient/userservice/model';
// @ts-ignore
import type { ErrorResponse } from '../../../../../../org/dataland/datalandfrontend/openApiClient/userservice/model';
// @ts-ignore
import type { PortfolioMonitoringPatch } from '../../../../../../org/dataland/datalandfrontend/openApiClient/userservice/model';
// @ts-ignore
import type { PortfolioSharingPatch } from '../../../../../../org/dataland/datalandfrontend/openApiClient/userservice/model';
// @ts-ignore
import type { PortfolioUpload } from '../../../../../../org/dataland/datalandfrontend/openApiClient/userservice/model';
// @ts-ignore
import type { PortfolioUserAccessRight } from '../../../../../../org/dataland/datalandfrontend/openApiClient/userservice/model';
// @ts-ignore
import type { SupportRequestData } from '../../../../../../org/dataland/datalandfrontend/openApiClient/userservice/model';
/**
 * PortfolioControllerApi - axios parameter creator
 */
export const PortfolioControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Post a new portfolio.
         * @param {PortfolioUpload} portfolioUpload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPortfolio: async (portfolioUpload: PortfolioUpload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portfolioUpload' is not null or undefined
            assertParamExists('createPortfolio', 'portfolioUpload', portfolioUpload)
            const localVarPath = `/portfolios/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(portfolioUpload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The currently logged-in user is removed from the list of users with whom the portfolio is shared.
         * @summary Delete the sharing of a portfolio for the currently logged-in user.
         * @param {string} portfolioId The unique identifier to identify the portfolio.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCurrentUserFromSharing: async (portfolioId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portfolioId' is not null or undefined
            assertParamExists('deleteCurrentUserFromSharing', 'portfolioId', portfolioId)
            const localVarPath = `/portfolios/shared/{portfolioId}`
                .replace(`{${"portfolioId"}}`, encodeURIComponent(String(portfolioId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete the portfolio with given portfolioId entirely
         * @summary Delete an existing portfolio.
         * @param {string} portfolioId The unique identifier to identify the portfolio.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePortfolio: async (portfolioId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portfolioId' is not null or undefined
            assertParamExists('deletePortfolio', 'portfolioId', portfolioId)
            const localVarPath = `/portfolios/{portfolioId}/`
                .replace(`{${"portfolioId"}}`, encodeURIComponent(String(portfolioId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * All portfolio names for the currently logged-in user are retrieved.
         * @summary Get all portfolio names for the currently logged-in user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPortfolioNamesForCurrentUser: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/portfolios/names`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a segment of all portfolios for the given chunk size and index.
         * @param {number} [chunkSize] Only a chunk of all matching, ordered results is returned. This parameter specifies the maximum size of a single chunk. All chunks except possibly the last will have that size.
         * @param {number} [chunkIndex] Only a chunk of all matching, ordered results is returned. This parameter specifies which chunk to return, starting at 0. The default value is 0, meaning the first chunk is returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPortfolios: async (chunkSize?: number, chunkIndex?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/portfolios/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            if (chunkSize !== undefined) {
                localVarQueryParameter['chunkSize'] = chunkSize;
            }

            if (chunkIndex !== undefined) {
                localVarQueryParameter['chunkIndex'] = chunkIndex;
            }

            localVarHeaderParameter['Accept'] = '*/*,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * All portfolios for the currently logged-in user are retrieved.
         * @summary Get all portfolios for the currently logged-in user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPortfoliosForCurrentUser: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/portfolios/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * All shared portfolio names for the currently logged-in user are retrieved.
         * @summary Get all shared portfolio names for the currently logged-in user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSharedPortfolioNamesForCurrentUser: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/portfolios/shared/names`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * All shared portfolios for the currently logged-in user are retrieved.
         * @summary Get all shared portfolios for the currently logged-in user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSharedPortfoliosForCurrentUser: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/portfolios/shared`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get enriched portfolio by portfolioId.
         * @param {string} portfolioId The unique identifier to identify the portfolio.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnrichedPortfolio: async (portfolioId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portfolioId' is not null or undefined
            assertParamExists('getEnrichedPortfolio', 'portfolioId', portfolioId)
            const localVarPath = `/portfolios/{portfolioId}/enriched-portfolio`
                .replace(`{${"portfolioId"}}`, encodeURIComponent(String(portfolioId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get portfolio by portfolioId.
         * @param {string} portfolioId The unique identifier to identify the portfolio.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolio: async (portfolioId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portfolioId' is not null or undefined
            assertParamExists('getPortfolio', 'portfolioId', portfolioId)
            const localVarPath = `/portfolios/{portfolioId}/`
                .replace(`{${"portfolioId"}}`, encodeURIComponent(String(portfolioId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves user details and access rights for all users with access rights to this portfolio.
         * @summary Get access rights for all users with access rights to this portfolio.
         * @param {string} portfolioId The unique identifier to identify the portfolio.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolioAccessRights: async (portfolioId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portfolioId' is not null or undefined
            assertParamExists('getPortfolioAccessRights', 'portfolioId', portfolioId)
            const localVarPath = `/portfolios/{portfolioId}/access-rights`
                .replace(`{${"portfolioId"}}`, encodeURIComponent(String(portfolioId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get portfolios by userId.
         * @param {string} userId The user ID of the user who created the portfolio.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfoliosForUser: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getPortfoliosForUser', 'userId', userId)
            const localVarPath = `/portfolios/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the monitoring-related fields of an existing portfolio.
         * @summary Patches the monitoring status of a portfolio.
         * @param {string} portfolioId The unique identifier to identify the portfolio.
         * @param {PortfolioMonitoringPatch} portfolioMonitoringPatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchMonitoring: async (portfolioId: string, portfolioMonitoringPatch: PortfolioMonitoringPatch, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portfolioId' is not null or undefined
            assertParamExists('patchMonitoring', 'portfolioId', portfolioId)
            // verify required parameter 'portfolioMonitoringPatch' is not null or undefined
            assertParamExists('patchMonitoring', 'portfolioMonitoringPatch', portfolioMonitoringPatch)
            const localVarPath = `/portfolios/{portfolioId}/monitoring`
                .replace(`{${"portfolioId"}}`, encodeURIComponent(String(portfolioId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(portfolioMonitoringPatch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the list of user IDs with whom an existing portfolio is shared.
         * @summary Patch the portfolio sharing of a portfolio.
         * @param {string} portfolioId The unique identifier to identify the portfolio.
         * @param {PortfolioSharingPatch} portfolioSharingPatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchSharing: async (portfolioId: string, portfolioSharingPatch: PortfolioSharingPatch, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portfolioId' is not null or undefined
            assertParamExists('patchSharing', 'portfolioId', portfolioId)
            // verify required parameter 'portfolioSharingPatch' is not null or undefined
            assertParamExists('patchSharing', 'portfolioSharingPatch', portfolioSharingPatch)
            const localVarPath = `/portfolios/{portfolioId}/sharing`
                .replace(`{${"portfolioId"}}`, encodeURIComponent(String(portfolioId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(portfolioSharingPatch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Request support for creating a portfolio on Dataland.
         * @summary Request support for creating a portfolio.
         * @param {SupportRequestData} supportRequestData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSupportRequest: async (supportRequestData: SupportRequestData, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supportRequestData' is not null or undefined
            assertParamExists('postSupportRequest', 'supportRequestData', supportRequestData)
            const localVarPath = `/portfolios/support`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(supportRequestData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replace the existing portfolio with given portfolioId entirely
         * @summary Replace an existing portfolio.
         * @param {string} portfolioId The unique identifier to identify the portfolio.
         * @param {PortfolioUpload} portfolioUpload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replacePortfolio: async (portfolioId: string, portfolioUpload: PortfolioUpload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portfolioId' is not null or undefined
            assertParamExists('replacePortfolio', 'portfolioId', portfolioId)
            // verify required parameter 'portfolioUpload' is not null or undefined
            assertParamExists('replacePortfolio', 'portfolioUpload', portfolioUpload)
            const localVarPath = `/portfolios/{portfolioId}/`
                .replace(`{${"portfolioId"}}`, encodeURIComponent(String(portfolioId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(portfolioUpload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PortfolioControllerApi - functional programming interface
 */
export const PortfolioControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PortfolioControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Post a new portfolio.
         * @param {PortfolioUpload} portfolioUpload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPortfolio(portfolioUpload: PortfolioUpload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BasePortfolio>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPortfolio(portfolioUpload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortfolioControllerApi.createPortfolio']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The currently logged-in user is removed from the list of users with whom the portfolio is shared.
         * @summary Delete the sharing of a portfolio for the currently logged-in user.
         * @param {string} portfolioId The unique identifier to identify the portfolio.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCurrentUserFromSharing(portfolioId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCurrentUserFromSharing(portfolioId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortfolioControllerApi.deleteCurrentUserFromSharing']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete the portfolio with given portfolioId entirely
         * @summary Delete an existing portfolio.
         * @param {string} portfolioId The unique identifier to identify the portfolio.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePortfolio(portfolioId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePortfolio(portfolioId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortfolioControllerApi.deletePortfolio']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * All portfolio names for the currently logged-in user are retrieved.
         * @summary Get all portfolio names for the currently logged-in user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPortfolioNamesForCurrentUser(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BasePortfolioName>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPortfolioNamesForCurrentUser(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortfolioControllerApi.getAllPortfolioNamesForCurrentUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a segment of all portfolios for the given chunk size and index.
         * @param {number} [chunkSize] Only a chunk of all matching, ordered results is returned. This parameter specifies the maximum size of a single chunk. All chunks except possibly the last will have that size.
         * @param {number} [chunkIndex] Only a chunk of all matching, ordered results is returned. This parameter specifies which chunk to return, starting at 0. The default value is 0, meaning the first chunk is returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPortfolios(chunkSize?: number, chunkIndex?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BasePortfolio>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPortfolios(chunkSize, chunkIndex, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortfolioControllerApi.getAllPortfolios']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * All portfolios for the currently logged-in user are retrieved.
         * @summary Get all portfolios for the currently logged-in user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPortfoliosForCurrentUser(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BasePortfolio>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPortfoliosForCurrentUser(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortfolioControllerApi.getAllPortfoliosForCurrentUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * All shared portfolio names for the currently logged-in user are retrieved.
         * @summary Get all shared portfolio names for the currently logged-in user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllSharedPortfolioNamesForCurrentUser(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BasePortfolioName>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllSharedPortfolioNamesForCurrentUser(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortfolioControllerApi.getAllSharedPortfolioNamesForCurrentUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * All shared portfolios for the currently logged-in user are retrieved.
         * @summary Get all shared portfolios for the currently logged-in user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllSharedPortfoliosForCurrentUser(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BasePortfolio>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllSharedPortfoliosForCurrentUser(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortfolioControllerApi.getAllSharedPortfoliosForCurrentUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get enriched portfolio by portfolioId.
         * @param {string} portfolioId The unique identifier to identify the portfolio.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEnrichedPortfolio(portfolioId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnrichedPortfolio>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEnrichedPortfolio(portfolioId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortfolioControllerApi.getEnrichedPortfolio']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get portfolio by portfolioId.
         * @param {string} portfolioId The unique identifier to identify the portfolio.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPortfolio(portfolioId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BasePortfolio>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPortfolio(portfolioId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortfolioControllerApi.getPortfolio']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves user details and access rights for all users with access rights to this portfolio.
         * @summary Get access rights for all users with access rights to this portfolio.
         * @param {string} portfolioId The unique identifier to identify the portfolio.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPortfolioAccessRights(portfolioId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PortfolioUserAccessRight>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPortfolioAccessRights(portfolioId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortfolioControllerApi.getPortfolioAccessRights']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get portfolios by userId.
         * @param {string} userId The user ID of the user who created the portfolio.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPortfoliosForUser(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BasePortfolio>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPortfoliosForUser(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortfolioControllerApi.getPortfoliosForUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the monitoring-related fields of an existing portfolio.
         * @summary Patches the monitoring status of a portfolio.
         * @param {string} portfolioId The unique identifier to identify the portfolio.
         * @param {PortfolioMonitoringPatch} portfolioMonitoringPatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchMonitoring(portfolioId: string, portfolioMonitoringPatch: PortfolioMonitoringPatch, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BasePortfolio>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchMonitoring(portfolioId, portfolioMonitoringPatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortfolioControllerApi.patchMonitoring']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the list of user IDs with whom an existing portfolio is shared.
         * @summary Patch the portfolio sharing of a portfolio.
         * @param {string} portfolioId The unique identifier to identify the portfolio.
         * @param {PortfolioSharingPatch} portfolioSharingPatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchSharing(portfolioId: string, portfolioSharingPatch: PortfolioSharingPatch, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BasePortfolio>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchSharing(portfolioId, portfolioSharingPatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortfolioControllerApi.patchSharing']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Request support for creating a portfolio on Dataland.
         * @summary Request support for creating a portfolio.
         * @param {SupportRequestData} supportRequestData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postSupportRequest(supportRequestData: SupportRequestData, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postSupportRequest(supportRequestData, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortfolioControllerApi.postSupportRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Replace the existing portfolio with given portfolioId entirely
         * @summary Replace an existing portfolio.
         * @param {string} portfolioId The unique identifier to identify the portfolio.
         * @param {PortfolioUpload} portfolioUpload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replacePortfolio(portfolioId: string, portfolioUpload: PortfolioUpload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BasePortfolio>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replacePortfolio(portfolioId, portfolioUpload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortfolioControllerApi.replacePortfolio']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PortfolioControllerApi - factory interface
 */
export const PortfolioControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PortfolioControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Post a new portfolio.
         * @param {PortfolioUpload} portfolioUpload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPortfolio(portfolioUpload: PortfolioUpload, options?: RawAxiosRequestConfig): AxiosPromise<BasePortfolio> {
            return localVarFp.createPortfolio(portfolioUpload, options).then((request) => request(axios, basePath));
        },
        /**
         * The currently logged-in user is removed from the list of users with whom the portfolio is shared.
         * @summary Delete the sharing of a portfolio for the currently logged-in user.
         * @param {string} portfolioId The unique identifier to identify the portfolio.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCurrentUserFromSharing(portfolioId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCurrentUserFromSharing(portfolioId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete the portfolio with given portfolioId entirely
         * @summary Delete an existing portfolio.
         * @param {string} portfolioId The unique identifier to identify the portfolio.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePortfolio(portfolioId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePortfolio(portfolioId, options).then((request) => request(axios, basePath));
        },
        /**
         * All portfolio names for the currently logged-in user are retrieved.
         * @summary Get all portfolio names for the currently logged-in user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPortfolioNamesForCurrentUser(options?: RawAxiosRequestConfig): AxiosPromise<Array<BasePortfolioName>> {
            return localVarFp.getAllPortfolioNamesForCurrentUser(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a segment of all portfolios for the given chunk size and index.
         * @param {number} [chunkSize] Only a chunk of all matching, ordered results is returned. This parameter specifies the maximum size of a single chunk. All chunks except possibly the last will have that size.
         * @param {number} [chunkIndex] Only a chunk of all matching, ordered results is returned. This parameter specifies which chunk to return, starting at 0. The default value is 0, meaning the first chunk is returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPortfolios(chunkSize?: number, chunkIndex?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<BasePortfolio>> {
            return localVarFp.getAllPortfolios(chunkSize, chunkIndex, options).then((request) => request(axios, basePath));
        },
        /**
         * All portfolios for the currently logged-in user are retrieved.
         * @summary Get all portfolios for the currently logged-in user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPortfoliosForCurrentUser(options?: RawAxiosRequestConfig): AxiosPromise<Array<BasePortfolio>> {
            return localVarFp.getAllPortfoliosForCurrentUser(options).then((request) => request(axios, basePath));
        },
        /**
         * All shared portfolio names for the currently logged-in user are retrieved.
         * @summary Get all shared portfolio names for the currently logged-in user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSharedPortfolioNamesForCurrentUser(options?: RawAxiosRequestConfig): AxiosPromise<Array<BasePortfolioName>> {
            return localVarFp.getAllSharedPortfolioNamesForCurrentUser(options).then((request) => request(axios, basePath));
        },
        /**
         * All shared portfolios for the currently logged-in user are retrieved.
         * @summary Get all shared portfolios for the currently logged-in user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSharedPortfoliosForCurrentUser(options?: RawAxiosRequestConfig): AxiosPromise<Array<BasePortfolio>> {
            return localVarFp.getAllSharedPortfoliosForCurrentUser(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get enriched portfolio by portfolioId.
         * @param {string} portfolioId The unique identifier to identify the portfolio.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnrichedPortfolio(portfolioId: string, options?: RawAxiosRequestConfig): AxiosPromise<EnrichedPortfolio> {
            return localVarFp.getEnrichedPortfolio(portfolioId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get portfolio by portfolioId.
         * @param {string} portfolioId The unique identifier to identify the portfolio.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolio(portfolioId: string, options?: RawAxiosRequestConfig): AxiosPromise<BasePortfolio> {
            return localVarFp.getPortfolio(portfolioId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves user details and access rights for all users with access rights to this portfolio.
         * @summary Get access rights for all users with access rights to this portfolio.
         * @param {string} portfolioId The unique identifier to identify the portfolio.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolioAccessRights(portfolioId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PortfolioUserAccessRight>> {
            return localVarFp.getPortfolioAccessRights(portfolioId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get portfolios by userId.
         * @param {string} userId The user ID of the user who created the portfolio.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfoliosForUser(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<BasePortfolio>> {
            return localVarFp.getPortfoliosForUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the monitoring-related fields of an existing portfolio.
         * @summary Patches the monitoring status of a portfolio.
         * @param {string} portfolioId The unique identifier to identify the portfolio.
         * @param {PortfolioMonitoringPatch} portfolioMonitoringPatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchMonitoring(portfolioId: string, portfolioMonitoringPatch: PortfolioMonitoringPatch, options?: RawAxiosRequestConfig): AxiosPromise<BasePortfolio> {
            return localVarFp.patchMonitoring(portfolioId, portfolioMonitoringPatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the list of user IDs with whom an existing portfolio is shared.
         * @summary Patch the portfolio sharing of a portfolio.
         * @param {string} portfolioId The unique identifier to identify the portfolio.
         * @param {PortfolioSharingPatch} portfolioSharingPatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchSharing(portfolioId: string, portfolioSharingPatch: PortfolioSharingPatch, options?: RawAxiosRequestConfig): AxiosPromise<BasePortfolio> {
            return localVarFp.patchSharing(portfolioId, portfolioSharingPatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Request support for creating a portfolio on Dataland.
         * @summary Request support for creating a portfolio.
         * @param {SupportRequestData} supportRequestData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSupportRequest(supportRequestData: SupportRequestData, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postSupportRequest(supportRequestData, options).then((request) => request(axios, basePath));
        },
        /**
         * Replace the existing portfolio with given portfolioId entirely
         * @summary Replace an existing portfolio.
         * @param {string} portfolioId The unique identifier to identify the portfolio.
         * @param {PortfolioUpload} portfolioUpload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replacePortfolio(portfolioId: string, portfolioUpload: PortfolioUpload, options?: RawAxiosRequestConfig): AxiosPromise<BasePortfolio> {
            return localVarFp.replacePortfolio(portfolioId, portfolioUpload, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PortfolioControllerApi - interface
 */
export interface PortfolioControllerApiInterface {
    /**
     * 
     * @summary Post a new portfolio.
     * @param {PortfolioUpload} portfolioUpload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPortfolio(portfolioUpload: PortfolioUpload, options?: RawAxiosRequestConfig): AxiosPromise<BasePortfolio>;

    /**
     * The currently logged-in user is removed from the list of users with whom the portfolio is shared.
     * @summary Delete the sharing of a portfolio for the currently logged-in user.
     * @param {string} portfolioId The unique identifier to identify the portfolio.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCurrentUserFromSharing(portfolioId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Delete the portfolio with given portfolioId entirely
     * @summary Delete an existing portfolio.
     * @param {string} portfolioId The unique identifier to identify the portfolio.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePortfolio(portfolioId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * All portfolio names for the currently logged-in user are retrieved.
     * @summary Get all portfolio names for the currently logged-in user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAllPortfolioNamesForCurrentUser(options?: RawAxiosRequestConfig): AxiosPromise<Array<BasePortfolioName>>;

    /**
     * 
     * @summary Get a segment of all portfolios for the given chunk size and index.
     * @param {number} [chunkSize] Only a chunk of all matching, ordered results is returned. This parameter specifies the maximum size of a single chunk. All chunks except possibly the last will have that size.
     * @param {number} [chunkIndex] Only a chunk of all matching, ordered results is returned. This parameter specifies which chunk to return, starting at 0. The default value is 0, meaning the first chunk is returned.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAllPortfolios(chunkSize?: number, chunkIndex?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<BasePortfolio>>;

    /**
     * All portfolios for the currently logged-in user are retrieved.
     * @summary Get all portfolios for the currently logged-in user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAllPortfoliosForCurrentUser(options?: RawAxiosRequestConfig): AxiosPromise<Array<BasePortfolio>>;

    /**
     * All shared portfolio names for the currently logged-in user are retrieved.
     * @summary Get all shared portfolio names for the currently logged-in user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAllSharedPortfolioNamesForCurrentUser(options?: RawAxiosRequestConfig): AxiosPromise<Array<BasePortfolioName>>;

    /**
     * All shared portfolios for the currently logged-in user are retrieved.
     * @summary Get all shared portfolios for the currently logged-in user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAllSharedPortfoliosForCurrentUser(options?: RawAxiosRequestConfig): AxiosPromise<Array<BasePortfolio>>;

    /**
     * 
     * @summary Get enriched portfolio by portfolioId.
     * @param {string} portfolioId The unique identifier to identify the portfolio.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEnrichedPortfolio(portfolioId: string, options?: RawAxiosRequestConfig): AxiosPromise<EnrichedPortfolio>;

    /**
     * 
     * @summary Get portfolio by portfolioId.
     * @param {string} portfolioId The unique identifier to identify the portfolio.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPortfolio(portfolioId: string, options?: RawAxiosRequestConfig): AxiosPromise<BasePortfolio>;

    /**
     * Retrieves user details and access rights for all users with access rights to this portfolio.
     * @summary Get access rights for all users with access rights to this portfolio.
     * @param {string} portfolioId The unique identifier to identify the portfolio.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPortfolioAccessRights(portfolioId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PortfolioUserAccessRight>>;

    /**
     * 
     * @summary Get portfolios by userId.
     * @param {string} userId The user ID of the user who created the portfolio.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPortfoliosForUser(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<BasePortfolio>>;

    /**
     * Updates the monitoring-related fields of an existing portfolio.
     * @summary Patches the monitoring status of a portfolio.
     * @param {string} portfolioId The unique identifier to identify the portfolio.
     * @param {PortfolioMonitoringPatch} portfolioMonitoringPatch 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchMonitoring(portfolioId: string, portfolioMonitoringPatch: PortfolioMonitoringPatch, options?: RawAxiosRequestConfig): AxiosPromise<BasePortfolio>;

    /**
     * Updates the list of user IDs with whom an existing portfolio is shared.
     * @summary Patch the portfolio sharing of a portfolio.
     * @param {string} portfolioId The unique identifier to identify the portfolio.
     * @param {PortfolioSharingPatch} portfolioSharingPatch 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchSharing(portfolioId: string, portfolioSharingPatch: PortfolioSharingPatch, options?: RawAxiosRequestConfig): AxiosPromise<BasePortfolio>;

    /**
     * Request support for creating a portfolio on Dataland.
     * @summary Request support for creating a portfolio.
     * @param {SupportRequestData} supportRequestData 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postSupportRequest(supportRequestData: SupportRequestData, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Replace the existing portfolio with given portfolioId entirely
     * @summary Replace an existing portfolio.
     * @param {string} portfolioId The unique identifier to identify the portfolio.
     * @param {PortfolioUpload} portfolioUpload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    replacePortfolio(portfolioId: string, portfolioUpload: PortfolioUpload, options?: RawAxiosRequestConfig): AxiosPromise<BasePortfolio>;

}

/**
 * PortfolioControllerApi - object-oriented interface
 */
export class PortfolioControllerApi extends BaseAPI implements PortfolioControllerApiInterface {
    /**
     * 
     * @summary Post a new portfolio.
     * @param {PortfolioUpload} portfolioUpload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createPortfolio(portfolioUpload: PortfolioUpload, options?: RawAxiosRequestConfig) {
        return PortfolioControllerApiFp(this.configuration).createPortfolio(portfolioUpload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The currently logged-in user is removed from the list of users with whom the portfolio is shared.
     * @summary Delete the sharing of a portfolio for the currently logged-in user.
     * @param {string} portfolioId The unique identifier to identify the portfolio.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteCurrentUserFromSharing(portfolioId: string, options?: RawAxiosRequestConfig) {
        return PortfolioControllerApiFp(this.configuration).deleteCurrentUserFromSharing(portfolioId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete the portfolio with given portfolioId entirely
     * @summary Delete an existing portfolio.
     * @param {string} portfolioId The unique identifier to identify the portfolio.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deletePortfolio(portfolioId: string, options?: RawAxiosRequestConfig) {
        return PortfolioControllerApiFp(this.configuration).deletePortfolio(portfolioId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * All portfolio names for the currently logged-in user are retrieved.
     * @summary Get all portfolio names for the currently logged-in user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllPortfolioNamesForCurrentUser(options?: RawAxiosRequestConfig) {
        return PortfolioControllerApiFp(this.configuration).getAllPortfolioNamesForCurrentUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a segment of all portfolios for the given chunk size and index.
     * @param {number} [chunkSize] Only a chunk of all matching, ordered results is returned. This parameter specifies the maximum size of a single chunk. All chunks except possibly the last will have that size.
     * @param {number} [chunkIndex] Only a chunk of all matching, ordered results is returned. This parameter specifies which chunk to return, starting at 0. The default value is 0, meaning the first chunk is returned.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllPortfolios(chunkSize?: number, chunkIndex?: number, options?: RawAxiosRequestConfig) {
        return PortfolioControllerApiFp(this.configuration).getAllPortfolios(chunkSize, chunkIndex, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * All portfolios for the currently logged-in user are retrieved.
     * @summary Get all portfolios for the currently logged-in user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllPortfoliosForCurrentUser(options?: RawAxiosRequestConfig) {
        return PortfolioControllerApiFp(this.configuration).getAllPortfoliosForCurrentUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * All shared portfolio names for the currently logged-in user are retrieved.
     * @summary Get all shared portfolio names for the currently logged-in user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllSharedPortfolioNamesForCurrentUser(options?: RawAxiosRequestConfig) {
        return PortfolioControllerApiFp(this.configuration).getAllSharedPortfolioNamesForCurrentUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * All shared portfolios for the currently logged-in user are retrieved.
     * @summary Get all shared portfolios for the currently logged-in user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllSharedPortfoliosForCurrentUser(options?: RawAxiosRequestConfig) {
        return PortfolioControllerApiFp(this.configuration).getAllSharedPortfoliosForCurrentUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get enriched portfolio by portfolioId.
     * @param {string} portfolioId The unique identifier to identify the portfolio.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getEnrichedPortfolio(portfolioId: string, options?: RawAxiosRequestConfig) {
        return PortfolioControllerApiFp(this.configuration).getEnrichedPortfolio(portfolioId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get portfolio by portfolioId.
     * @param {string} portfolioId The unique identifier to identify the portfolio.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPortfolio(portfolioId: string, options?: RawAxiosRequestConfig) {
        return PortfolioControllerApiFp(this.configuration).getPortfolio(portfolioId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves user details and access rights for all users with access rights to this portfolio.
     * @summary Get access rights for all users with access rights to this portfolio.
     * @param {string} portfolioId The unique identifier to identify the portfolio.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPortfolioAccessRights(portfolioId: string, options?: RawAxiosRequestConfig) {
        return PortfolioControllerApiFp(this.configuration).getPortfolioAccessRights(portfolioId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get portfolios by userId.
     * @param {string} userId The user ID of the user who created the portfolio.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPortfoliosForUser(userId: string, options?: RawAxiosRequestConfig) {
        return PortfolioControllerApiFp(this.configuration).getPortfoliosForUser(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the monitoring-related fields of an existing portfolio.
     * @summary Patches the monitoring status of a portfolio.
     * @param {string} portfolioId The unique identifier to identify the portfolio.
     * @param {PortfolioMonitoringPatch} portfolioMonitoringPatch 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public patchMonitoring(portfolioId: string, portfolioMonitoringPatch: PortfolioMonitoringPatch, options?: RawAxiosRequestConfig) {
        return PortfolioControllerApiFp(this.configuration).patchMonitoring(portfolioId, portfolioMonitoringPatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the list of user IDs with whom an existing portfolio is shared.
     * @summary Patch the portfolio sharing of a portfolio.
     * @param {string} portfolioId The unique identifier to identify the portfolio.
     * @param {PortfolioSharingPatch} portfolioSharingPatch 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public patchSharing(portfolioId: string, portfolioSharingPatch: PortfolioSharingPatch, options?: RawAxiosRequestConfig) {
        return PortfolioControllerApiFp(this.configuration).patchSharing(portfolioId, portfolioSharingPatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Request support for creating a portfolio on Dataland.
     * @summary Request support for creating a portfolio.
     * @param {SupportRequestData} supportRequestData 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postSupportRequest(supportRequestData: SupportRequestData, options?: RawAxiosRequestConfig) {
        return PortfolioControllerApiFp(this.configuration).postSupportRequest(supportRequestData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replace the existing portfolio with given portfolioId entirely
     * @summary Replace an existing portfolio.
     * @param {string} portfolioId The unique identifier to identify the portfolio.
     * @param {PortfolioUpload} portfolioUpload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public replacePortfolio(portfolioId: string, portfolioUpload: PortfolioUpload, options?: RawAxiosRequestConfig) {
        return PortfolioControllerApiFp(this.configuration).replacePortfolio(portfolioId, portfolioUpload, options).then((request) => request(this.axios, this.basePath));
    }
}

